export type CrewsStore = {
  fetchCrews: boolean;
};

export const initialState: CrewsStore = {
  fetchCrews: false,
};
